import { PermissionCodes } from "@/constants/permissionCodes";
import useAppStore from "@/context/store";
import { useHomeUrl } from "@/utils/getHomeUrl";
import classNames from "classnames";
import GdPermission from "../GdPermission";
import HBLogo from "../HBLogo";
import OrgSwitchDropdown from "../OrgSwitchDropdown";
import { TrackerA } from "../Tracker";
import styles from "./index.module.less";

export default function LogoWithOrg({ isCollapsed }) {
  const user = useAppStore((state) => state.user);
  const logoLink = useHomeUrl(user);

  return (
    <div
      className={classNames(styles.header, { [styles.collapsed]: isCollapsed })}
    >
      <TrackerA
        href={logoLink}
        className={styles.logo}
        data-gd-click="button_click"
        data-module-name="顶部导航栏"
        data-subject-name="按钮"
        data-button-name="LOGO"
        rel="nofollow"
      >
        <HBLogo size={40} style={{ padding: 5 }} />
      </TrackerA>

      {user && (
        <GdPermission code={PermissionCodes.changeOrgTypeWithTop}>
          <>
            <div className={classNames([styles.divider])} />
            <OrgSwitchDropdown isCollapsed={isCollapsed} />
          </>
        </GdPermission>
      )}
    </div>
  );
}
